// extracted by mini-css-extract-plugin
export default {"form-card":"Common_form-card__YLJ+2","form-title":"Common_form-title__saQQw","form-actions":"Common_form-actions__6E6l1","uploadButton":"Common_uploadButton__+I+fl"};